// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import { Api } from "../../api";
import { Branche } from "../../common/interfaces/conversionworld/Branche";
import InlineSVG from "../inline_svg/InlineSVG";
import { ImageAspectRatio } from "../image_aspect_ratio/ImageAspectRatio";
import { News } from "../../common/interfaces/News";
import { getTranslatedImage as getTranslatedImageHelper } from "../../common/ModuleHelpers";
import { BranchenDetail } from "./branchen_detail/BranchenDetail";
import { PopularSolution } from "../../common/interfaces/conversionworld/PopularSolution";

@Component({
  mixins: [template],
  components: {
    InlineSVG,
    ImageAspectRatio,
    BranchenDetail,
  },
})
export class ConversionworldMenu extends Vue {
  @Prop()
  public pageId!: number;

  @Prop()
  public portalId!: number;

  private popularSolution: PopularSolution | null = null;

  private news: News | null = null;

  private selectedBranchenId: string | null = null;

  public created() {
    this.loadBranchen();
    this.loadNews();
    this.loadPopularSolution();
  }

  get branchen() {
    return this.$store.conversionWorld.branchen;
  }

  get popularSolutionBranchenIndexed() {
    let result = {};

    if (this.popularSolution) {
      this.popularSolution.branchen.forEach((branche) => {
        result[branche.branche_id] = branche.links;
      });
    }

    return result;
  }

  getPopularSolutionLinksForBranchenId(id) {
    return this.popularSolutionBranchenIndexed[id] || [];
  }

  public handleEventBusOpenLayer() {}

  public async loadPopularSolution() {
    this.popularSolution = await Api.conversionWorldService.getPopularSolution(
      this.pageId
    );
  }

  public async loadBranchen() {
    this.$store.conversionWorld.loadBranchen(this.pageId);
  }

  public async loadNews() {
    let result = await Api.pageService.getNews(this.portalId, 1, 0);
    if (result && result.resultList && result.resultList[0]) {
      this.news = result.resultList[0];
    } else {
      return null;
    }
  }

  public get selectedBranche() {
    if (this.selectedBranchenId) {
      return this.branchen.find((b) => b.id == this.selectedBranchenId);
    } else {
      return undefined;
    }
  }

  public get newsLink() {
    if (this.news) {
      let news = this.news.news;
      if (
        news["content"].hasOwnProperty("alternativeLink") &&
        news["content"]["alternativeLink"] &&
        news["content"]["alternativeLink"]["href"]
      ) {
        return news["content"]["alternativeLink"]["href"];
      } else {
        return this.news.basic.route
          .replace("{lang}", this.$store.ui.appCurrentLanguage)
          .replace("{country}", this.$store.ui.appCurrentCountry);
      }
    } else {
      return "";
    }
  }

  public onSelectBranche(id, event) {
    event.preventDefault();
    if (this.selectedBranchenId == id) {
      this.selectedBranchenId = null;
    } else {
      this.selectedBranchenId = id;
    }
  }

  getTranslatedImage(imageObject, language, size) {
    return getTranslatedImageHelper(imageObject, language, size);
  }

  public onCloseMenu() {
    // @ts-ignore
    this.$parent.closeFlyout();
    this.$emit("close-menu");
  }
}
